/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioCategory } from './';
import {
    PortfolioCategoryFromJSON,
    PortfolioCategoryFromJSONTyped,
    PortfolioCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItemSummaryResource
 */
export interface PortfolioItemSummaryResource {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemSummaryResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemSummaryResource
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemSummaryResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemSummaryResource
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemSummaryResource
     */
    thumbnail: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioItemSummaryResource
     */
    index: number;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioItemSummaryResource
     */
    published: boolean;
    /**
     * 
     * @type {PortfolioCategory}
     * @memberof PortfolioItemSummaryResource
     */
    category?: PortfolioCategory;
    /**
     * ID of the linked profile experience, if any
     * @type {string}
     * @memberof PortfolioItemSummaryResource
     */
    experienceId?: string;
}

/**
 * Check if a given object implements the PortfolioItemSummaryResource interface.
 */
export function instanceOfPortfolioItemSummaryResource(value: object): value is PortfolioItemSummaryResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('thumbnail' in value) || value['thumbnail'] === undefined) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    return true;
}

export function PortfolioItemSummaryResourceFromJSON(json: any): PortfolioItemSummaryResource {
    return PortfolioItemSummaryResourceFromJSONTyped(json, false);
}

export function PortfolioItemSummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItemSummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'profileId': json['profileId'],
        'title': json['title'],
        'description': json['description'],
        'thumbnail': json['thumbnail'],
        'index': json['index'],
        'published': json['published'],
        'category': json['category'] == null ? undefined : PortfolioCategoryFromJSON(json['category']),
        'experienceId': json['experienceId'] == null ? undefined : json['experienceId'],
    };
}

export function PortfolioItemSummaryResourceToJSON(value?: PortfolioItemSummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'profileId': value['profileId'],
        'title': value['title'],
        'description': value['description'],
        'thumbnail': value['thumbnail'],
        'index': value['index'],
        'published': value['published'],
        'category': PortfolioCategoryToJSON(value['category']),
        'experienceId': value['experienceId'],
    };
}

